/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ ØµÙØ­Ù',
  jump_to: 'Ø¨Ø±Ù Ø¨Ù',
  jump_to_confirm: 'ØªØ§ÛÛØ¯',
  page: '',

  // Pagination.jsx
  prev_page: 'ØµÙØ­Ù ÙØ¨ÙÛ',
  next_page: 'ØµÙØ­Ù Ø¨Ø¹Ø¯Û',
  prev_5: 'Ûµ ØµÙØ­Ù ÙØ¨ÙÛ',
  next_5: 'Ûµ ØµÙØ­Ù Ø¨Ø¹Ø¯Û',
  prev_3: 'Û³ ØµÙØ­Ù ÙØ¨ÙÛ',
  next_3: 'Û³ ØµÙØ­Ù Ø¨Ø¹Ø¯Û'
};
